/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Hold_CreatedInputs */

const en_inventory_hold_created = /** @type {(inputs: Inventory_Hold_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventory hold created`)
};

const es_inventory_hold_created = /** @type {(inputs: Inventory_Hold_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apartado de inventario creado`)
};

/**
* | output |
* | --- |
* | "Inventory hold created" |
*
* @param {Inventory_Hold_CreatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_hold_created = /** @type {((inputs?: Inventory_Hold_CreatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Hold_CreatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_hold_created(inputs)
	return es_inventory_hold_created(inputs)
});